export const HOME_URL = import.meta.env.PUBLIC_HOME_URL;
export const DOC_URL = import.meta.env.PUBLIC_DOC_URL;
export const OFFICE_URL = import.meta.env.PUBLIC_OFFICE_URL;
export const AUTH_URL = import.meta.env.PUBLIC_AUTH_URL;

export const PAGE_403 = '/403';
export const PAGE_404 = '/404';
export const PAGE_500 = '/500';

export const PAGE_MY_PAGE = `${HOME_URL}/my/account`;
export const PAGE_MY_PAGE_PAYMENT = `${HOME_URL}/my/payment`;
export const PAGE_DOC = `${DOC_URL}`;
export const PAGE_OPEN_API = `${DOC_URL}/api/open-api`;
export const PAGE_INQUIRY = `${HOME_URL}/resource/inquiry`;
export const PAGE_LOGOUT = `${AUTH_URL}/logout`;
export const PAGE_LOGIN = `${AUTH_URL}/login`;
export const PAGE_DEFAULT = '/dashboard';
export const GUIDE_LINK_URL = `${DOC_URL}/guide`;

export const BILLING_PAYMENT_ROUTE = `/billing/payment/index`;
export const ORG_INFO_ROUTE = `/organization/info/index`;

export const STEP_STATUS = {
  WAIT: 'wait',
  PROCESS: 'process',
  FINISH: 'finish',
  ERROR: 'error',
} as const;

export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100, 200];
